import { ArrowForward } from '@mui/icons-material'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  ChipProps,
  IconButton,
  Typography,
  useTheme,

} from '@mui/material'
import { ComponentType, FC, ReactElement,   PropsWithChildren } from 'react'
import { useNavigate } from 'react-router'
import { LightbulbOutlinedIcon } from '../../icons'
import { StyledIconButton } from '../../Button'

interface HighlightCardProps {
  actionIcon?: ReactElement
  status?:
    | 'default'
    | 'inherit'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'primary'
    | 'secondary'
    | undefined
  chipProps?: ChipProps
  contentHeader?: string
  contentBody?: ComponentType<any> | ComponentType<any>[] | string | string[] | ReactElement | ReactElement[] | null | undefined
  contentText?: string
  actionText?: string
  onClickAction?: () => void
  centerContent?: boolean
  horizontal?:boolean
}

export const HighlightCard: FC<HighlightCardProps & PropsWithChildren> = ({
  actionIcon,
  status = 'primary',
  chipProps,
  contentHeader,
  contentBody,
  contentText,
  actionText,
  onClickAction,
  centerContent,
  horizontal,
  children

}) => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Card

      sx={{

      //m:'4px',
      height:'100%',
      display:'flex',
      p:1,
      flexDirection: horizontal ? 'row' : 'column',
      border: `1px solid ${theme.palette.grey[200]}`,
      alignItems: centerContent ? 'center' : 'flex-start',
      justifyContent:'flex-start'}}>
      <CardHeader
        avatar={
          actionIcon ? (
            <StyledIconButton status={status} actionIcon={actionIcon} />

          ) : null
        }
        action={chipProps ? <Chip size="small" sx={{ fontSize: '11px' }} {...chipProps} /> : null}
      ></CardHeader>
      <CardContent sx={{
        pb:'16px !important',flexGrow:1, textAlign: centerContent ? 'center' : 'left', width: '100%'}}>

        {contentHeader && <Typography variant="h5">{contentHeader}</Typography>}
        {contentText && <Typography variant="body-small">{contentText}</Typography> }
        {children}

      </CardContent>
      {onClickAction &&
      <CardActions>
        <Button
          variant="text"
          onClick={onClickAction}
          sx={{
            '& .MuiButton-endIcon > *:nth-of-type(1)': {
              fontSize: '14px',
            },
          }}
          endIcon={<ArrowForward />}
        >
          {actionText || 'View Details'}
        </Button>
      </CardActions>
      }
    </Card>
  )
}
